 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTML00_COVER from '@/components/xhtml/00_Cover'
 import XHTML01_HALFTITLE from '@/components/xhtml/01_Halftitle'
 import XHTML02_TITLE from '@/components/xhtml/02_Title'
 import XHTML03_COPYRIGHT from '@/components/xhtml/03_Copyright'
 import XHTMLTOC from '@/components/xhtml/Toc'
 import XHTML04_PREFACE from '@/components/xhtml/04_Preface'
 import XHTML05_INTRO from '@/components/xhtml/05_Intro'
 import XHTML06_ENGINEERS from '@/components/xhtml/06_Engineers'
 import XHTML07_CHAPTER01 from '@/components/xhtml/07_Chapter01'
 import XHTML08_CHAPTER02 from '@/components/xhtml/08_Chapter02'
 import XHTML09_CHAPTER03 from '@/components/xhtml/09_Chapter03'
 import XHTML10_CHAPTER04 from '@/components/xhtml/10_Chapter04'
 import XHTML11_CHAPTER05 from '@/components/xhtml/11_Chapter05'
 import XHTML12_CHAPTER06 from '@/components/xhtml/12_Chapter06'
 import XHTML13_CHAPTER07 from '@/components/xhtml/13_Chapter07'
 import XHTML14_CHAPTER08 from '@/components/xhtml/14_Chapter08'
 import XHTML15_APPENDIX from '@/components/xhtml/15_Appendix'
 import XHTML16_BIB from '@/components/xhtml/16_Bib'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/00_Cover",
 			"name" : "xhtml/00_Cover",
 			"component" : XHTML00_COVER
 		},
 		{
 			"path" : "/xhtml/01_Halftitle",
 			"name" : "xhtml/01_Halftitle",
 			"component" : XHTML01_HALFTITLE
 		},
 		{
 			"path" : "/xhtml/02_Title",
 			"name" : "xhtml/02_Title",
 			"component" : XHTML02_TITLE
 		},
 		{
 			"path" : "/xhtml/03_Copyright",
 			"name" : "xhtml/03_Copyright",
 			"component" : XHTML03_COPYRIGHT
 		},
 		{
 			"path" : "/xhtml/Toc",
 			"name" : "xhtml/Toc",
 			"component" : XHTMLTOC
 		},
 		{
 			"path" : "/xhtml/04_Preface",
 			"name" : "xhtml/04_Preface",
 			"component" : XHTML04_PREFACE
 		},
 		{
 			"path" : "/xhtml/05_Intro",
 			"name" : "xhtml/05_Intro",
 			"component" : XHTML05_INTRO
 		},
 		{
 			"path" : "/xhtml/06_Engineers",
 			"name" : "xhtml/06_Engineers",
 			"component" : XHTML06_ENGINEERS
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js